import TopicConfigs from './TopicConfigs';

export default TopicConfigs;
